// MUI Imports
import type { Theme } from '@mui/material/styles';

export const MuiChip: Theme['components'] = {
  MuiChip: {
    variants: [
      {
        props: { variant: 'tonal', color: 'primary' },
        style: {
          backgroundColor: 'var(--mui-palette-primary-lightOpacity)',
          color: 'var(--mui-palette-primary-main)',
          '&.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-primary-mainOpacity)',
          },
          '& .MuiChip-deleteIcon': {
            color: 'rgb(var(--mui-palette-primary-mainChannel) / 0.7)',
            '&:hover': {
              color: 'var(--mui-palette-primary-main)',
            },
          },
          '&.MuiChip-clickable:hover': {
            backgroundColor: 'var(--mui-palette-primary-main)',
            color: 'var(--mui-palette-common-white)',
          },
        },
      },
      {
        props: { variant: 'tonal', color: 'secondary' },
        style: {
          backgroundColor: 'var(--mui-palette-secondary-lightOpacity)',
          color: 'var(--mui-palette-secondary-main)',
          '&.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-secondary-mainOpacity)',
          },
          '& .MuiChip-deleteIcon': {
            color: 'rgb(var(--mui-palette-secondary-mainChannel) / 0.7)',
            '&:hover': {
              color: 'var(--mui-palette-secondary-main)',
            },
          },
          '&.MuiChip-clickable:hover': {
            backgroundColor: 'var(--mui-palette-secondary-main)',
            color: 'var(--mui-palette-common-white)',
          },
        },
      },
      {
        props: { variant: 'tonal', color: 'error' },
        style: {
          backgroundColor: 'var(--mui-palette-error-lightOpacity)',
          color: 'var(--mui-palette-error-main)',
          '&.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-error-mainOpacity)',
          },
          '& .MuiChip-deleteIcon': {
            color: 'rgb(var(--mui-palette-error-mainChannel) / 0.7)',
            '&:hover': {
              color: 'var(--mui-palette-error-main)',
            },
          },
          '&.MuiChip-clickable:hover': {
            backgroundColor: 'var(--mui-palette-error-main)',
            color: 'var(--mui-palette-common-white)',
          },
        },
      },
      {
        props: { variant: 'tonal', color: 'warning' },
        style: {
          backgroundColor: 'var(--mui-palette-warning-lightOpacity)',
          color: 'var(--mui-palette-warning-main)',
          '&.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-warning-mainOpacity)',
          },
          '& .MuiChip-deleteIcon': {
            color: 'rgb(var(--mui-palette-warning-mainChannel) / 0.7)',
            '&:hover': {
              color: 'var(--mui-palette-warning-main)',
            },
          },
          '&.MuiChip-clickable:hover': {
            backgroundColor: 'var(--mui-palette-warning-main)',
            color: 'var(--mui-palette-common-white)',
          },
        },
      },
      {
        props: { variant: 'tonal', color: 'info' },
        style: {
          backgroundColor: 'var(--mui-palette-info-lightOpacity)',
          color: 'var(--mui-palette-info-main)',
          '&.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-info-mainOpacity)',
          },
          '& .MuiChip-deleteIcon': {
            color: 'rgb(var(--mui-palette-info-mainChannel) / 0.7)',
            '&:hover': {
              color: 'var(--mui-palette-info-main)',
            },
          },
          '&.MuiChip-clickable:hover': {
            backgroundColor: 'var(--mui-palette-info-main)',
            color: 'var(--mui-palette-common-white)',
          },
        },
      },
      {
        props: { variant: 'tonal', color: 'success' },
        style: {
          backgroundColor: 'var(--mui-palette-success-lightOpacity)',
          color: 'var(--mui-palette-success-main)',
          '&.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-success-mainOpacity)',
          },
          '& .MuiChip-deleteIcon': {
            color: 'rgb(var(--mui-palette-success-mainChannel) / 0.7)',
            '&:hover': {
              color: 'var(--mui-palette-success-main)',
            },
          },
          '&.MuiChip-clickable:hover': {
            backgroundColor: 'var(--mui-palette-success-main)',
            color: 'var(--mui-palette-common-white)',
          },
        },
      },
      {
        props: { variant: 'tonal', color: 'turquoise' },
        style: {
          backgroundColor: 'var(--mui-palette-turquoise-opacity-10)',
          color: 'var(--mui-palette-turquoise-600)',
          '&.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-turquoise-opacity-10)',
          },
          '& .MuiChip-deleteIcon': {
            color: 'var(--mui-palette-turquoise-500)',
            '&:hover': {
              color: 'var(--mui-palette-turquoise-600)',
            },
          },
          '&.MuiChip-clickable:hover': {
            backgroundColor: 'var(--mui-palette-turquoise-500)',
            color: 'var(--mui-palette-common-white)',
          },
        },
      },
      {
        props: { variant: 'outlined', color: 'turquoise' },
        style: {
          backgroundColor: 'var(--mui-palette-turquoise-opacity-10)',
          color: 'var(--mui-palette-turquoise-600)',
          border: ' 1px solid var(--mui-palette-turquoise-600)',
          '&.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-turquoise-opacity-10)',
          },
          '& .MuiChip-deleteIcon': {
            color: 'var(--mui-palette-turquoise-500)',
            '&:hover': {
              color: 'var(--mui-palette-turquoise-600)',
            },
          },
          '&.MuiChip-clickable:hover': {
            backgroundColor: 'var(--mui-palette-turquoise-500)',
            color: 'var(--mui-palette-common-white)',
          },
        },
      },
    ],
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        // ...theme.typography.body2,
        fontSize: ownerState.size === 'small' ? 11 : 13,
        // fontWeight: theme.typography.fontWeightMedium,
        fontWeight: 500,
        height: ownerState.size === 'small' ? 20 : ownerState.size === 'large' ? 32 : 24,

        '& .MuiChip-deleteIcon': {
          ...(ownerState.size === 'small'
            ? {
                fontSize: '1rem',
                marginInlineEnd: theme.spacing(1),
                marginInlineStart: theme.spacing(-2),
              }
            : ownerState.size === 'large'
              ? {
                  fontSize: '1.375rem',
                  marginInlineEnd: theme.spacing(2),
                  marginInlineStart: theme.spacing(-3),
                }
              : {
                  fontSize: '1rem',
                  marginInlineEnd: theme.spacing(2),
                  marginInlineStart: theme.spacing(-3),
                }),
        },

        '& .MuiChip-avatar, & .MuiChip-icon': {
          '& i, & svg': {
            ...(ownerState.size === 'small'
              ? { fontSize: 13 }
              : ownerState.size === 'large'
                ? { fontSize: 17 }
                : { fontSize: 15 }),
          },
          ...(ownerState.size === 'small'
            ? {
                height: 16,
                width: 16,
                marginInlineStart: theme.spacing(1),
                marginInlineEnd: theme.spacing(-2),
              }
            : ownerState.size === 'large'
              ? {
                  height: 24,
                  width: 24,
                  marginInlineStart: theme.spacing(2),
                  marginInlineEnd: theme.spacing(-3),
                }
              : {
                  height: 20,
                  width: 20,
                  marginInlineStart: theme.spacing(2),
                  marginInlineEnd: theme.spacing(-3),
                }),
        },
      }),
      label: ({ ownerState, theme }) => ({
        ...(ownerState.size === 'small'
          ? { paddingInline: theme.spacing(3) }
          : ownerState.size === 'large'
            ? { paddingInline: theme.spacing(5) }
            : { paddingInline: theme.spacing(4) }),
      }),
      iconMedium: {
        fontSize: '1.25rem',
      },
      iconSmall: {
        fontSize: '1rem',
      },
    },
  },
};
